import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';

import App from './containers/App';
import configStore from './store';
import { installSessionGuard } from './router/sessionGuard';

import './styles/';

const store = configStore();

installSessionGuard();

const siteUrlInput = document.getElementById('siteUrl');
if (siteUrlInput) {
    siteUrlInput.value = process.env.siteUrl || '';
}

const container = document.getElementById('infinity-web-app');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <DndProvider backend={HTML5Backend}>
            <App />
        </DndProvider>
    </Provider>,
);
